import React from 'react';
import { SearchButtonBox, FilterColumn } from '../../IdCards/styled';
import { SearchFiltersProps } from '../types/ProvisionalPromotionTypes';
import Icons from '../../../components/icons';
import DropdownSelect from '../../../components/DropdownSelect';
import { Button } from '@mui/material';
import { PaperWrapper } from '../../common/styled';

const SearchFilters: React.FC<SearchFiltersProps> = ({
  grade,
  division,
  gradeOptions,
  divisionOptions,
  loading,
  onGradeChange,
  onDivisionChange,
  onSearch
}) => {
  const handleGradeChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    onGradeChange(e.target.value as string);
  };
  const handleDivisionChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | (Event & { target: { value: unknown; name: string } })
  ) => {
    onDivisionChange(e.target.value as string);
  };

  return (
    <PaperWrapper>
      <FilterColumn>
        <DropdownSelect
          label='Grade'
          name='grade'
          value={grade || ''}
          onChange={handleGradeChange}
          options={gradeOptions}
          hasTopLabel
          placeholder={'Select Grade'}
        />
      </FilterColumn>
      <FilterColumn>
        <DropdownSelect
          label='Division'
          name='division'
          value={division || ''}
          onChange={handleDivisionChange}
          options={divisionOptions}
          hasTopLabel
          placeholder={'Select Division'}
          disabled={!grade}
        />
      </FilterColumn>
      <SearchButtonBox>
        <Button
          variant='contained'
          disabled={!grade}
          onClick={onSearch}
          loading={loading}
        >
          <Icons.SearchWhiteOutlined style={{ marginRight: '6px' }} />
          Search Students
        </Button>
      </SearchButtonBox>
    </PaperWrapper>
  );
};

export default SearchFilters;
